import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { ChangeReportConfigAlert } from "../../../components/reportConfig/ChangeReportConfigAlert";
import { CertificateConfigForm } from "../../../components/reportConfig/form/CertificateConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import { ReportType } from "../../../models/enums/reportType";
import type { Group } from "../../../models/group";
import type { CertificateConfiguration } from "../../../models/reportConfigs/certificateConfiguration";
import type { Signature } from "../../../models/signature";
import type { YearContext } from "../../../models/yearContext";
import { report_configuration_path, report_configurations_path } from "../../../routes";

type JumpCertificateConfigEditProps = {
  jumpstart_config: CertificateConfiguration;
  year_contexts: YearContext[];
  groups: Group[];
  has_reports: boolean;
  signatures: Signature[];
};

export default function JumpCertificateConfigEdit({
  year_contexts,
  groups,
  jumpstart_config,
  has_reports,
  signatures,
}: JumpCertificateConfigEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(report_configuration_path, jumpstart_config.id), values);

  return (
    <ContentShell
      title={`JUMPStart Zertifikat-Vorlage ${jumpstart_config.title}`}
      onBack={() => router.get(pathWithYearContext(report_configurations_path))}
    >
      <CertificateConfigForm
        signatures={signatures}
        alert={has_reports && <ChangeReportConfigAlert />}
        certificateConfig={jumpstart_config}
        yearContexts={year_contexts}
        groups={groups}
        saveButtonLabel="Speichern"
        onSubmit={onSubmit}
        reportType={ReportType.JUMP}
      />
    </ContentShell>
  );
}
